import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.dashboard');
import { OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.dashboard/view.scss */
/* src/app/portal.lpsysadmin.dashboard/view.scss: no such file or directory */`],
})
export class PortalLpsysadminDashboardComponent implements OnInit {
    public operating: any[] = [];
    public formed: any[] = [];
    public posts: any[] = [];
    public members: any[] = [];
    public pending_approvals: any[] = [];
    public loaded: boolean = false;
    public target_user: any = null;

    public selectedPost: any = null;
    public postComments: any[] = [];
    public postLoading: boolean = false;

    public categoryMap: any = {
        notice: '공지사항',
        community: '커뮤니티',
        qna: '문의사항',
        expert: '전문가풀',
        general: '일반',
        media: '미디어',
        news: '기업현황',
        report: '운용보고',
        company_log: '활동기록',
        company_comment: '관리이력',
        investment: '투자',
        company_tech: '기술동향',
        company_business: '사업현황',
        company_overseas: '해외진출',
        company_support: '지원사업',
        company_patent: '특허',
        company_financial: '재무정보',
        company_workforce: '인력현황',
    };

    public statusMap: any = {
        draft: '임시저장',
        pending: '승인대기',
        approved: '승인완료',
        rejected: '반려',
        withdrawn: '회수',
        revision_requested: '보완요청'
    };

    public gpList: string[] = [];
    public selectedGps: string[] = [];
    public showGpSettings: boolean = false;

    public async toggleGpSettings() {
        this.showGpSettings = !this.showGpSettings;
        this.cdr.detectChanges();
    }

    public async loadGpSettings() {
        const gpRes = await wiz.call("gp_list");
        if (gpRes.code == 200) {
            this.gpList = gpRes.data.gp_list;
        }
        const settingsRes = await wiz.call("gp_settings_load");
        if (settingsRes.code == 200 && settingsRes.data.settings?.selected_gps) {
            this.selectedGps = settingsRes.data.settings.selected_gps;
        }

        this.cdr.detectChanges();
    }

    public isGpSelected(gp: string): boolean {
        return this.selectedGps.includes(gp);
    }

    public async toggleGp(gp: string) {
        const idx = this.selectedGps.indexOf(gp);
        if (idx >= 0) {
            this.selectedGps.splice(idx, 1);
        } else {
            this.selectedGps.push(gp);
        }
        this.cdr.detectChanges();
    }

    public async saveGpSettings() {
        await wiz.call("gp_settings_save", { selected_gps: JSON.stringify(this.selectedGps) });
        this.showGpSettings = false;
        await this.loadDashboard();
        this.cdr.detectChanges();
    }

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        try {
            await this.loadGpSettings();
            //await this.loadDashboard();
        } catch (e) {
            console.error('GP settings/dashboard load error:', e);
        }
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code === 200) {
            this.operating = data.operating || [];
            this.formed = data.formed || [];
            this.posts = data.posts || [];
            this.members = data.members || [];
            this.pending_approvals = data.pending_approvals || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public goFund(item: any) {
        this.service.href(`/admin/invest/fund/formed/${item.id}/info`);
    }

    public getCategoryClass(category: string): string {
        if (category === 'notice') return 'bg-blue-50 text-blue-700';
        if (category === 'investment') return 'bg-amber-50 text-amber-700';
        if (category && category.startsWith('company_')) return 'bg-emerald-50 text-emerald-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public async openPost(item: any) {
        this.postLoading = true;
        this.selectedPost = item;
        this.postComments = [];
        await this.service.render();

        const { code, data } = await wiz.call("feed_detail", {
            id: item.id,
            feed_type: item.feed_type || 'board'
        });
        if (code === 200) {
            this.selectedPost = data.item;
            this.postComments = data.comments || [];
        }
        this.postLoading = false;
        await this.service.render();
    }

    public async closePost() {
        this.selectedPost = null;
        this.postComments = [];
        await this.service.render();
    }

    public goBoard() {
        this.service.href('/admin/invest/board/all');
    }

    public goApproval(item: any) {
        this.service.href(`/admin/system/approval/pending/${item.id}`);
    }

    public goApprovalList() {
        this.service.href('/admin/system/approval/pending');
    }

    public async goMember(item: any) {
        this.target_user = null;
        await this.service.render();
        this.target_user = item.id;
        await this.service.render();
    }

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            await this.service.render();
        }
    };

    public formatter = {
        date: (val: string) => {
            if (!val) return '-';
            return val.substring(0, 10);
        },
        amount: (val: number) => {
            if (!val) return '0';
            return val.toLocaleString();
        }
    };
}

export default PortalLpsysadminDashboardComponent;